import styled from 'styled-components';
import { colorCardinal } from '@tds/core-colours';

export const FooterMessage = styled.p`
  font-size: 14px;
  color: ${colorCardinal};
  font-weight: 500;
`;

export const FooterErrorContainer = styled.div`
  margin-left: 1.2rem;
`;
